import { render, staticRenderFns } from "./pay-result.vue?vue&type=template&id=3f74d807&scoped=true&"
import script from "./pay-result.vue?vue&type=script&lang=js&"
export * from "./pay-result.vue?vue&type=script&lang=js&"
import style0 from "./pay-result.vue?vue&type=style&index=0&id=3f74d807&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f74d807",
  null
  
)

component.options.__file = "pay-result.vue"
export default component.exports